module.exports = __webpack_public_path__ + "static/img/14000134.c8f173ee.png";